module.exports = __webpack_public_path__ + "img/icon9.944cf130.png";